<template>
  <div class="info-container normal-font">

    <div class="row justify-end">
      <q-btn
          round
          dense
          flat
          icon="close"
          color="primary"
          @click="router.back()"
      />
    </div>

    <h5>1. Booking & Payment</h5>
    <p>
      A booking becomes binding with a deposit of <strong>€50</strong>. The deposit will be deducted from the total price of the service. The
      remaining balance must be paid on-site, unless otherwise agreed. Payment methods via <strong>Stripe</strong> are available,
      allowing the customer to pay conveniently by credit card or other supported payment methods.
    </p>
    <p>
      In the event of early cancellation by the customer, the deposit will only be refunded if this has been expressly agreed. Otherwise, the
      deposit remains as compensation for the service not rendered.
    </p>
    <h5>2. Deposits & Cancellations</h5>
    <p>The deposit secures the appointment.</p>
    <p>
      <strong>Cancellation by the customer:</strong> In case of cancellation up to <strong>2 days before the appointment</strong>, the deposit
      remains valid and will be credited toward a new appointment. The cancellation must be submitted in writing via email to info@pay-r.de.
    </p>
    <p>
      In case of later cancellations or no-shows, the deposit will be forfeited unless the customer proves that a lesser damage occurred. In
      this case, the customer must provide appropriate evidence (e.g., medical certificate or other documents).
    </p>
    <h5>3. Changes to the Appointment by the Service Provider</h5>
    <p>
      If an appointment must be rescheduled for important reasons, the deposit remains valid and will be transferred to the new appointment.
      The customer will be informed in a timely manner. The customer has the right to withdraw from the contract and receive a refund of the
      deposit if they disagree with the new appointment arrangement.
    </p>
    <h5>4. Punctuality & Process</h5>
    <p>
      The customer is obligated to arrive on time. In case of delay, the agreed-upon time will be shortened accordingly; lost time will not be
      made up.
    </p>
    <p>
      Respectful and appropriate behavior is a prerequisite for the service to be carried out. In case of
      <strong>serious violations</strong> (e.g., insults, harassment, discriminatory remarks), the service provider may terminate the service.
      In such cases, there is no entitlement to a refund. A serious violation occurs when the customer's behavior endangers the service or
      harasses the service provider in an unacceptable manner.
    </p>
    <h5>5. Liability</h5>
    <p>
      The service provider is fully liable for damages resulting from injuries to <strong>life, body, and health</strong> caused by willful or
      negligent breach of duty.
    </p>
    <p>
      For other damages, the service provider is only liable in case of <strong>intent</strong> or <strong>gross negligence</strong>. Any
      further liability is excluded.
    </p>
    <p>
      Before the first session, the customer is required to sign a separate notice and clarification form. Without this signature, the session
      cannot take place. This applies to all sessions conducted in contexts involving special risks (e.g., personal services).
    </p>
    <h5>6. Chargebacks & Legal Notices</h5>
    <p>Unauthorized chargebacks may result in the blocking of the customer contact and may be pursued legally.</p>
    <p>
      The statutory <strong>right of withdrawal for consumers</strong> applies to distance contracts. The customer can withdraw from the
      contract within 14 days without giving a reason. However, the right of withdrawal expires if the service has already been fully
      provided. Further details can be found in the separate <strong>cancellation policy</strong>.
    </p>
    <h5>7. Data Protection</h5>
    <p>
      All customer data is used solely for the performance of the contract and treated confidentially. Disclosure to third parties only occurs
      if it is necessary for the fulfillment of the contract or if there is a legal obligation. Further details on the processing of personal
      data and the rights of the affected individuals can be found in our <strong>Privacy Policy</strong>.
    </p>
    <h5>8. Final Provisions</h5>
    <p>
      By booking an appointment, the customer accepts these terms and conditions. Changes are reserved, provided they are communicated to the
      customer <strong>before the contract is concluded</strong>. German law applies. The place of jurisdiction is
      <strong>Frankfurt am Main</strong>, if the customer is a merchant or has their habitual residence outside of Germany.
    </p>

    <div class="row justify-center">
      <q-btn
          no-caps
          flat
          size="lg"
          color="primary"
          label="Back"
          icon="arrow_back_ios"
          @click="router.back()"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'

const router = useRouter()

</script>
